module.exports = __webpack_public_path__ + "media/images/new_landing/people/dominika-dragunova-81f3302fd16ec4712593466e9dbf3837.jpg";